export default __webpack_public_path__ + "static/media/Graph.acfe24a4.svg";